import type { SerializedFirebaseTimestamp } from "@/components/PromoTimer";

export function hasTimePassed(timestamp: SerializedFirebaseTimestamp) {
    const timestampDate = new Date(timestamp._seconds * 1000 + timestamp._nanoseconds / 1000000);
    const currentDate = new Date();
    return timestampDate < currentDate;
  }
  
export function addHoursToTimestamp(timestamp: SerializedFirebaseTimestamp, hoursToAdd: number) {
    const date = new Date(timestamp._seconds * 1000 + timestamp._nanoseconds / 1000000);
    date.setHours(date.getHours() + hoursToAdd);

    const newSeconds = Math.floor(date.getTime() / 1000);
    const newNanoseconds = (date.getTime() % 1000) * 1000000;

    return {
        _seconds: newSeconds,
        _nanoseconds: newNanoseconds
    };
}